<template>
  <div>
    <ManagePersonModal
      v-if="isManagePersonModalShowing"
      :personListType="currentProgram.personListType"
      :person="getPerson()"
      :onClose="onCloseManagePersonModal"
      :onUpdated="onUpdatePersons" />
    <Section>
      <template v-slot:section-header>
        <h5 class="title">ผู้ดำเนินรายการ/นักแสดง</h5>
        <div class="action">
          <div class="btn-container">
            <button
              type="button"
              class="btn btn-light"
              @click.stop="onCreate">
              เพิ่ม{{currentProgram.personListType}}
            </button>
          </div>
        </div>
      </template>
      <template v-slot:section-body>
        <div class="row">
          <div class="col-md-4">
            <FormGroup :errorMessage="getErrorMessage('personListType')">
              <h5 class="name">ประเภทของลิสต์</h5>
              <select class="form-control"
                  :value="currentProgram.personListType"
                  @change="$store.dispatch('setCurrentProgram', { personListType: $event.target.value })">
                <option v-for="(personName, personNameIndex) in personListTypeOptions"
                  :key="personNameIndex"
                  :value="personName">
                  {{personName}}
                </option>
              </select>
            </FormGroup>
          </div>
        </div>
        <List v-if="!isEmpty()">
          <template v-slot:list-body>
            <div class="list-item-container no-underline"
              v-for="(person, personIndex) in currentProgram.persons"
              :key="personIndex">
              <div class="list-item-image">
                <ImageView
                  :source="person.displayImage"
                  aspectRatio="1:1"
                  imageSize="cover320w320h" />
              </div>
              <div class="list-item-detail">
                <div class="list-item list-item-primary list-item-title">
                  {{person.firstName}} {{person.lastName}}
                  <div v-if="person.nickName">({{person.nickName}})</div>
                </div>
                <div class="list-item">
                  <span v-if="person.character">แสดงเป็น <strong>{{person.character}}</strong></span>
                </div>
                <div class="list-item list-item-action">
                  <div class="action-container">
                    <button
                      type="button"
                      class="btn btn-light btn-action"
                      @click.stop="onRemove(personIndex)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-light btn-action"
                      @click.stop="onEdit(personIndex)">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </List>
        <!-- empty gallery -->
        <EmptyMessage
          v-if="isEmpty()"
          class="empty-small">
          <h5 class="title">ไม่มี{{currentProgram.personListType}}</h5>
          <button
            type="button"
            class="btn btn-light mt-2"
            @click="onCreate">
            เลือก {{currentProgram.personListType}} สำหรับรายการนี้
          </button>
        </EmptyMessage>
      </template>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import FormGroup from '@/components/FormGroup.vue';
import Section from '@/components/Section.vue';
import List from '@/components/List.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import ImageView from '@/image/ImageView.vue';
import ManagePersonModal from './person/ManagePersonModal.vue';

export default {
  components: {
    FormGroup,
    Section,
    ImageView,
    List,
    EmptyMessage,
    ManagePersonModal,
  },
  data() {
    return {
      selectedPersonIndex: null,
      isManagePersonModalShowing: false,
      personListTypeOptions: ['นักแสดง', 'ผู้ดำเนินรายการ'],
    };
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      saveProgramState: (state) => state.programItem.saveProgramState,
    }),
  },
  methods: {
    isEmpty() {
      return _.isEmpty(this.currentProgram.persons);
    },
    updatePersons(newPersons) {
      this.$store.dispatch('setCurrentProgram', { persons: newPersons });
    },
    onRemove(personIndex) {
      const newPersons = _.remove(this.currentProgram.persons, (item, index) => index !== personIndex);
      this.updatePersons(newPersons);
    },
    onToggleManagePersonModal() {
      this.isManagePersonModalShowing = !this.isManagePersonModalShowing;
    },
    onCloseManagePersonModal() {
      this.selectedPersonIndex = null;
      this.isManagePersonModalShowing = false;
    },
    onCreate() {
      this.onToggleManagePersonModal();
    },
    onEdit(personIndex) {
      this.selectedPersonIndex = personIndex;
      this.onToggleManagePersonModal();
    },
    getPerson() {
      if (!_.isNull(this.selectedPersonIndex)) {
        return _.cloneDeep(this.currentProgram.persons[this.selectedPersonIndex]);
      }
      return {};
    },
    onUpdatePersons(newPerson) {
      if (!_.isNull(this.selectedPersonIndex)) {
        const newPersons = _.map(this.currentProgram.persons, (personItem, personIndex) => {
          if (personIndex === this.selectedPersonIndex) {
            return newPerson;
          }
          return personItem;
        });
        this.updatePersons(newPersons);
      } else {
        const newPersons = [...this.currentProgram.persons, newPerson];
        this.updatePersons(newPersons);
      }

      // close modal
      this.onCloseManagePersonModal();
    },
    getErrorMessage(fieldName) {
      return _.get(this.saveProgramState.error, `${fieldName}`, null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.list-item-container .list-item-image {
  flex: 0 0 80px;
}
</style>
